import { Component, Output, EventEmitter } from '@angular/core';
import { SceneUtilsService } from '../services/scene-utils.service';
import { StageService } from '../services/stage.service';
declare let THREE: any;
import { ComponentBase } from '../component-base';
import { RemoveStairsService } from '../services/remove-stairs.service';
import { MoveStairsService } from '../services/move-stairs.service';
import { GenerateStairsService } from '../services/generate-stairs.service';
import { DragFloorEdge } from '../services/drag-floor-edge.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-add-stairs',
  templateUrl: './add-stairs.component.html',
  styleUrls: ['./add-stairs.component.scss']
})
export class AddStairsComponent extends ComponentBase {

  private raycaster: any = new THREE.Raycaster();
  currentStairType: any;
  selectedStairType = '';

  @Output() step1Editer = new EventEmitter();

  constructor(
    private sceneUtils: SceneUtilsService,
    private stage: StageService,
    private removeStairsService: RemoveStairsService,
    private moveStairsService: MoveStairsService,
    private generateStairs: GenerateStairsService,
    private dragFloorEdge: DragFloorEdge,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {
    super();
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.subscribe(value => {
      this.selectedStairType = value;
    });
  }

  goBack(value) {
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('')
    this.step1Editer.emit({ name: value });
  }

  mouseDown(e) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const floor = this.stage.getCompoundFloor();
    const sprites = this.stage.getSprites();
    const intersection = this.raycaster.intersectObjects([...floor.children, ...sprites]);
    if (!intersection.length) {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.remove();
    }
  }

  buildStair(stairType) {
    if (!this.generateStairs.isEnabled() || this.currentStairType !== stairType) {
      this.remove();
      this.generateStairs.enable();
      this.dragFloorEdge.disable();
      this.currentStairType = stairType;
      this.generateStairs.drawSprites(stairType);
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next(stairType);
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.generateStairs.disable();
      this.dragFloorEdge.enable();
      this.currentStairType = null;
    }
  }

  straightStair() {
    this.buildStair('straightStair');
  }

  stairLandingLeft() {
    this.buildStair('stairLandingLeft');
  }

  stairLandingRight() {
    this.buildStair('stairLandingRight');
  }

  stairLandingStraight() {
    this.buildStair('stairLandingStraight');
  }

  stairLandingBothSides() {
    this.buildStair('stairLandingBothSides');
  }

  removeStairs() {
    if (!this.removeStairsService.isEnabled()) {
      this.remove();
      this.removeStairsService.enable();
      this.removeStairsService.drawSprites();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('remove')
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('')
      this.removeStairsService.removeSprites();
      this.removeStairsService.disable();
    }
  }

  remove() {

    this.moveStairsService.removeSprites();
    this.generateStairs.disable();
    this.dragFloorEdge.enable();

    // this.moveCamera.enable();
    // this.orbit.enable();
  }

}



// WEBPACK FOOTER //
// ./src/app/add-stairs/add-stairs.component.ts